"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mail = void 0;
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.Mail = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
    React.createElement("path", { fill: props.fill || common_styles_1.black, stroke: props.stroke || common_styles_1.black, d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" }))); };
//# sourceMappingURL=mail.js.map